export default {
  "compare_data": "Compare data",
  "open_platform": "LeFu Open Platform",
  "faster_cheaper": "Faster, Cheaper, Easier Development, Faster Ownership",
  "what_we_can_do": "What We Can Do",
  "custom_smart_scale": "Custom Smart Scale",
  "build_health_ecosystem": "Build your custom smart hardware, health management App, and health management platform using our smart scale as a carrier. One-stop solution to create your health management ecosystem.",
  "learn_more": "Learn More",
  "wechat_mini_program_integration": "Wechat Mini Program Integration",
  "low_cost_health_mini_program": "Low-cost development of health management mini programs. We provide various customization modes such as mini-program OEM customization, ODM deep customization, and self-development of mini-program plugins.",
  "view_docs": "View Docs",
  "app_integration": "App Integration",
  "ios_android_sdk": "Providing iOS and Android platform SDKs to help developers simplify the development process and implement Bluetooth protocol analysis and body data calculation functions.",
  "massive_food_data": "Massive Food Data",
  "easily_access_nutritional_info": "Easily access nutritional information, calories, ingredients, and more for various foods. Our service is based on authoritative food databases that cover millions of food items.",
  "why_choose_us": "Why Choose Us",
  "independent_research": "Independent Research",
  "professional_team": "We have a professional R&D team with over one hundred members. We have independently developed more than 30 practical patents, over 70 design patents, and over 20 software copyrights. The number of new patents added every year ranks among the top in the industry. After continuous efforts, we were honored as a Shenzhen high-tech enterprise in 2016. From project design and development to finalization, our strong R&D design team strictly controls every aspect.",
  "design_innovation": "Design Innovation",
  "professional_design_team": "Our company has a professional design team and maintains close cooperation with external professional design companies. We actively sponsor multiple industrial design innovation competitions. We provide each customer with an exclusive ID for design, ensuring uniqueness across all platforms after finalization and guaranteeing that each customer's product appearance is unique.",
  "comprehensive_quality_control": "Comprehensive Quality Control",
  "market_leader_quality": "As a manufacturing company, quality is our primary competitive advantage. In 2015, our company implemented ISO9001:2015 quality management system, followed by the introduction of ISO13485 medical management system in 2017. In 2018, we obtained CFDA production license. Our quality standards continue to improve. While demanding excellence from ourselves, we also establish high-standard assessment and management systems for suppliers to control quality at the source. Our quality standards are at the top level in the industry.",
  "software_customization": "Software Customization",
  "professional_stable_service": "Whether it's a mini-program or an app, we can provide professional, secure, and stable services. Our company has the largest software development team in this industry, with successful online cases numbering in the hundreds. Each position is manned by senior engineers, and the team currently has over 50 members, with rapid development.",
  "smart_manufacturing": "Smart Manufacturing",
  "logistics_automation": "LeFu's smart manufacturing production line realizes logistics conveying and automated production monitoring throughout the entire process from raw material online, processing, quality control to finished product offline. This improves our capability for quality control and flexible delivery, enabling more effective satisfaction of different customer needs.",
  "dedicated_service": "Dedicated Service",
  "pre_sales": "Pre-Sales: Help you understand the market situation of electronic scales, strengthen mutual understanding, and enable you to choose satisfactory products.",
  "in_sales": "In-Sales: Arrange product knowledge training; hold pre-production order review meetings to ensure smooth order delivery and product quality.",
  "after_sales": "After-Sales: 24/7 online support for any difficulties or questions you may have. We have a complete after-sales service process and management system.",
  "our_partners": "Our Partners",
  "login_register": "Login/Register",
  "personal_info": "Personal Information",
  "logout": "Logout",
  "language": "Language",
  "contact_email": "Contact Email",
  "product_center": "Product Center",
  "weight_scale": "Weight Scale",
  "body_fat_scale": "Body Fat Scale",
  "kitchen_scale": "Kitchen Scale",
  "2in1_nutrition_scale": "2-in-1 Nutrition Scale",
  "business_cooperation": "Business Cooperation",
  "cooperation_process": "Cooperation Process",
  "core_advantages": "Core Advantages",
  "customer_cases": "Customer Cases",
  "about_us": "About Us",
  "lefufu_intro": "Lefufu Introduction",
  "lefufu_culture": "Lefufu Culture",
  "talent_recruitment": "Talent Recruitment",
  "document_center": "Document Center",
  "homepage": "Homepage" ,
  "password_login": "Password login",
  "code_login": "Code login",
  "enter_account": "Enter account, email or phone number",
  "enter_password": "Enter password",
  "enter_email_or_phone": "Enter email or phone number",
  "get_verification_code": "Get verification code",
  "resend": "Resend",
  "enter_verification_code": "Enter verification code",
  "new_user_register": "New user? Register with SMS to automatically create an account",
  "agree_terms_conditions": "I have read and agree to the",
  "terms_privacy_policy": "Terms and Privacy Policy",
  "go_to_register": "Go to register",
  "login": "Login",
  "age_required": "Age is required",
  "enter_valid_number": "Please enter a valid number",
  "must_be_18_or_above": "Must be 18 years or older",
  "enter_username": "Enter username",
  "enter_valid_phone": "Please enter a valid phone number",
  "username_restrictions": "Username can only contain letters, numbers, and underscores, with a length of 3 to 16 characters",
  "phone_email_required": "Phone number and email cannot be empty",
  "enter_valid_phone_email": "Please enter a valid phone number or email address",
  "enter_valid_email_email": "Please enter a valid email address or email address",
  "enter_phone": "Please enter phone number",
  "enter_valid_phone_or_email": "Please enter a valid phone number or email",
  "accept_terms_privacy": "You need to accept the Terms and Privacy Policy",
  "login_success": "Login successful",
  "account_registration": "Account Registration",
  "phone_registration": "Phone Registration",
  "account": "Account",
  "password": "Password",
  "confirm_password": "Confirm Password",
  "email": "Email",
  "verification_code": "Verification code",
  "phone_number": "Phone number",
  "already_have_account": "Already have an account?",
  "direct_login": "Direct login",
  "register": "Register",
  "username_restrictions_2": "Username can only contain letters, numbers, and underscores, must include at least one letter, with a length of 3 to 16 characters",
  "password_requirements": "Password must be 6-20 characters long and include both numbers and letters",
  "enter_confirm_password": "Please enter confirm password",
  "passwords_do_not_match": "Passwords do not match",
  "enter_email": "Please enter email",
  "enter_valid_email": "Please enter a valid email",
  "basic_information": "Basic Information",
  "enter": "Enter",
  "nickname": "Nickname",
  "email_2": "Email",
  "once_filled_no_changes": "Once filled, cannot be changed. Please fill in carefully",
  "phone": "Phone",
  "registration_date": "Registration Date",
  "company_address": "Company Address",
  "position_in_company": "Position in Company",
  "select": "Select",
  "you_dont_have_appkey": "You don't have an appKey",
  "copy": "Copy",
  "view_my_appkey": "View my AppKey",
  "enter_nickname": "Please enter nickname",
  "length_between_2_20": "Length must be between 2 and 20 characters",
  "enter_registration_date": "Please enter registration date",
  "enter_company_name": "Please enter company name",
  "enter_company_address": "Please enter company address",
  "select_position": "Please select position",
  "male": "Male",
  "female": "Female",
  "secret": "Secret",
  "boss": "Boss",
  "operations": "Operations",
  "development": "Development",
  "product": "Product",
  "other": "Other",
  "copy_success": "Copied successfully!",
  "complete_user_company_info": "Please complete user and company information first",
  "download_my_config": "Get configuration",
  "download": "download",
  "registration_process_document": "Registration Process Document",
  "note": "Note: If account is not provided, you can authorize our account as a developer",
  "third_party_data_service": "Third Party Data Service",
  "operating_document": "Operating Document",
  "note2": "Note: If relevant information is not provided, this feature cannot be enabled",
  "information_related": "Information Related",
  "sender_email": "Sender Email",
  "default_use": "Default Use",
  "send_password_verification_code_email": "Send Password Verification Code Email",
  "sender_email_password": "Sender Email Password",
  "customer_service_email": "Customer Service Email",
  "company_name": "Company Name",
  "language_support": "Language Support",
  "please_select": "Please Select",
  "privacy_policy": "Privacy Policy",
  "user_agreement": "User Agreement",
  "company_abbreviation": "Company Abbreviation",
  "Joyful_Commerce": "Joyful Commerce",
  "Joyful_Commerce_contact": "Joyful Commerce Contact",
  "submit": "Submit",
  "cancel": "Cancel",
  "prompt": "Prompt",
  "need_to_acquire_first": "Need to Acquire First",
  "confirm": "Confirm",
  "age_cannot_be_blank": "Age cannot be blank",
  "please_enter_numeric_value": "Please enter numeric value",
  "please_enter_apple_id": "Please enter Apple ID",
  "please_enter_correct_apple_id": "Please enter correct Apple ID",
  "please_enter_google_id": "Please enter Google ID",
  "please_enter_correct_google_id": "Please enter correct Google ID",
  "cannot_be_blank": "Cannot be blank",
  "language_selection_required": "Language selection required",
  "incorrect": "Incorrect",
  "format_error": "Format error",
  "Simplified_Chinese": "Simplified Chinese",
  "Chinese_Taiwan": "Chinese Taiwan",
  "Arabic": "Arabic",
  "Czech": "Czech",
  "German": "German",
  "English": "English",
  "Spanish": "Spanish",
  "French": "French",
  "Hungarian": "Hungarian",
  "Italian": "Italian",
  "Japanese": "Japanese",
  "Korean": "Korean",
  "Dutch": "Dutch",
  "Polish": "Polish",
  "Portuguese": "Portuguese",
  "Russian": "Russian",
  "Vietnamese": "Vietnamese",
  "Thai": "Thai",
  "Indonesian": "Indonesian",
  "Turkish": "Turkish",
  "Danish": "Danish",
  "avatar_image_must_be_JPG": "Avatar image must be in JPG format!",
  "avatar_image_size_limit_2MB": "Avatar image size cannot exceed 2MB!",
  "default_use_email": "Default use uniqueLife@healthscale8.com to send password verification code email",
  "developer_information": "Developer Information",
  "custom_data": "Custom data",
  "contact_info_required": "Contact information must not be empty",
  "app_key": "My AppKey",
  "my_device": "My device",
  "add_device": "Add device",
  "device_name": "Bluetooth name(deviceName)",
  "advLength": "Broadcast data length(advLength)",
  "sign": "sign",
  "please_fill_in_the_required_fields": "Please fill in all required fields",
  "mini_program_access": "Mini Program Access",
  "android_access": "Android Access",
  "cloud_computing_library": "Cloud Computing Library",
  "ios_access": "IOS Access",
  "software_service": "Software service",
  "enter_phone_or_email": "Please enter your phone number or email address",
  "device_setting": "Device Configuration",
  "wait_for": "Coming soon",
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en_US.js